export default class ChangeLink
{
  constructor()
  {
    if (!this.setVars()) return;
    
    this.setEvents();
  }
  
  setVars()
  {
    this.settings = {
      wrapper: 'data-change-link'
    };
    
    this.change_link = document.querySelector(`[${this.settings.wrapper}]`);
    
    if (!this.change_link) return;
    
    return true;
  }
  
  setEvents()
  {
    this.change_link.addEventListener('change', (e) => {
      const url = e.target.value;
      
      if (url) {
        window.location = url;
      }
      
      return false;
    });
  }
}
